import NoDataChart from "./noDataChart.component";

export default NoDataChart;